"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESubChargeAnnuelleFoyerFiscalTrads = void 0;
exports.ESubChargeAnnuelleFoyerFiscalTrads = {
    between_15K_25K: "Entre 15 000 € et 25 000 €",
    between_25K_50K: "Entre 25 000 € et 50 000 €",
    between_5K_15K: "Entre 5 000 € et 15 000 €",
    greater_50K: "Supérieur à 50 000 €",
    less_5K: "Inférieur à 5 000 €",
};
